import {
  BarChartIcon,
  DataGrid,
  FindInPageOutlinedIcon,
  Flex,
  mergeSx,
  NoRowsOverlay,
  type DataGridProps,
} from '@shared/components';

import { columns } from './column';

interface BaseQBankOverviewListProps extends Omit<DataGridProps, 'columns'> {
  isSearching?: boolean;
}

function BaseQBankOverviewNoRowsOverlay(input: Readonly<{ isSearching?: boolean }>) {
  const { isSearching } = input;
  return isSearching ? (
    <Flex
      sx={{
        py: (theme) => theme.spacing(20),
        width: '100%',
      }}
    >
      <NoRowsOverlay
        title='ไม่พบข้อมูลที่ตรงกับการค้นหา'
        icon={FindInPageOutlinedIcon}
        slotProps={{
          icon: {
            fontSize: 100,
          },
          wrapper: {
            disablePadding: true,
          },
        }}
      />
    </Flex>
  ) : (
    <Flex
      sx={{
        py: (theme) => theme.spacing(20),
        width: '100%',
      }}
    >
      <NoRowsOverlay
        title='ยังไม่มีข้อมูลให้แสดง'
        icon={BarChartIcon}
        description='โปรดเลือกตัวกรองด้านบนก่อน เพื่อดูข้อมูลรายงานตามช่วงวันที่หรือเงื่อนไขที่ต้องการ'
        slotProps={{
          icon: {
            fontSize: 100,
          },
          wrapper: {
            disablePadding: true,
          },
        }}
      />
    </Flex>
  );
}

export default function BaseQBankOverviewList(props: Readonly<BaseQBankOverviewListProps>) {
  const { sx: sxProp, isSearching, ...restProps } = props;

  return (
    <DataGrid
      rowHeight={48}
      columns={columns}
      disableColumnMenu
      slots={{
        noRowsOverlay: () => <BaseQBankOverviewNoRowsOverlay isSearching={isSearching} />,
      }}
      sx={mergeSx(
        (theme) => ({
          border: `1px solid ${theme.palette.grey[300]}`,
          '--DataGrid-overlayHeight': '344px',
          borderRadius: theme.shape.rounded(2),
          bgcolor: theme.palette.background.paper,
          '.MuiDataGrid-columnHeaders': {
            bgcolor: theme.palette.grey[100],
            borderColor: theme.palette.grey[300],
          },
          '.MuiDataGrid-columnHeader': {
            px: theme.spacing(3),
          },
          '& .MuiDataGrid-row .MuiDataGrid-cell': {
            padding: theme.spacing(3),
          },
          '& .MuiDataGrid-cell, & .MuiDataGrid-row': {
            borderColor: theme.palette.grey[300],
          },
        }),
        sxProp,
      )}
      {...restProps}
    />
  );
}
